import { tv } from 'tailwind-variants'

export const dividerVariants = tv({
  base: 'bg-layout-divider',
  variants: {
    orientation: {
      horizontal: 'my-4 h-px w-full',
      vertical: 'mx-4 w-px h-full',
    },
  },
  defaultVariants: {
    orientation: 'horizontal',
  },
})
